<template>
  <section>
    <UnifiedFilterSearch
      :filterList="filterList"
      :itensFilter="getItemsFilter"
      :tabPersistName="tabPersistName"
      @search-value="getSearchValue"
      @filters="getFilterList"
    />
    <div class="level">
      <div class="level-left has-text-left">
        <span class="has-text-weight-semibold mr-15">
          {{ getPaginationDetails }}
        </span>
      </div>
    </div>
    <div v-if="observerPage" class="middle">
      <b-table
        class="custom-table-process-panel custom-8-columns"
        :data="
          isLoading || doePublishedList.count == 0 ? [] : doePublishedList.list
        "
        :sortIcon="sortIcon"
        :sortIconSize="sortIconSize"
        :checkedRows.sync="duePublishedList"
        :aria-next-label="General.NEXT_PAGE"
        :aria-previous-label="General.PREVIOUS_PAGE"
        :aria-page-label="General.PAGE"
        :aria-current-label="General.CURRENT_PAGE"
        :defaultSort="sortOrder"
        backendSorting
        hoverable
        role="table"
        @sort="onSort"
      >
        <template>
          <b-table-column
            v-slot="props"
            field="default"
            :label="isMobile ? '' : 'hiddenText'"
            headerClass="icons hidden-text"
            cellClass="icons"
            :sortable="!isMobile"
          >
            <div class="is-flex is-flex-wrap-wrap">
              <b-tooltip
                v-if="isConfidential(props.row)"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                position="is-right"
                :label="secrecyName(props.row)"
                class="ml-5"
                role="tooltip"
              >
                <div class="circle-red">
                  <b-icon
                    type="is-white"
                    icon="lock"
                    customSize="mdi-inherit"
                  />
                </div>
              </b-tooltip>
              <b-tooltip
                v-if="subjectIcons[props.row.process_file.priority.type]"
                :label="props.row.process_file.priority.name"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                position="is-right"
                role="tooltip"
              >
                <b-icon
                  :icon="
                    subjectIcons[props.row.process_file.priority.type].icon
                  "
                  :type="
                    subjectIcons[props.row.process_file.priority.type].color
                  "
                  class="ml-5"
                />
              </b-tooltip>
            </div>
          </b-table-column>
          <b-table-column :visible="!isMobile">
            <div></div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="process_file.nup"
            :label="General.NUP"
            :sortable="!isMobile"
          >
            <div class="has-text-color-8">
              {{ applyMaskNUP(props.row.process_file.nup) }}
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="process_file.attachment_name"
            :label="General.DOCUMENT"
            :sortable="!isMobile"
          >
            <div class="has-text-left">
              <routerLink
                class="has-text-color-8 has-text-weight-semibold custom-pointer has-overflow-wrap-anywhere"
                role="link"
                rel="search tag"
                :to="
                  `/app/documento/${props.row.process_file.id}?processId=${
                    props.row.process_file.process_id
                  }&doeProgramDate=${new Date(
                    props.row.program_date
                  ).getTime()}`
                "
              >
                {{ props.row.process_file.attachment_name }}
              </routerLink>

              <div class="has-text-color-8">
                <label class=" has-text-weight-semibold-500">
                  {{ General.TYPE }}:
                </label>
                <span>
                  {{ props.row.process_file.document_type }}
                </span>
              </div>

              <div class="has-text-color-8">
                <label class="has-text-weight-semibold-500">
                  {{ General.ADDED_ON }}:
                </label>
                <span>
                  {{ new Date(props.row.date) | dateFormat("DD-MM-YYYY") }}
                  {{
                    `às ${new Date(props.row.date).getHours()}h${new Date(
                      props.row.date
                    ).getMinutes()}m`
                  }}
                </span>
                <span class="has-text-weight-semibold-500">
                  {{ General.PER.toLowerCase() }}
                </span>
                <span>
                  {{
                    `${props.row.process_file.origin.entity.abbreviation}/${
                      props.row.process_file.origin.abbreviation.includes("/")
                        ? props.row.process_file.origin.abbreviation.split(
                            "/"
                          )[1]
                        : props.row.process_file.origin.abbreviation
                    }`
                  }}
                </span>
              </div>
            </div>
          </b-table-column>

          <b-table-column v-slot="props" cellClass="doe-sign-history">
            <SubscriptionHistoryView
              :signHistory="props.row.process_file.signature_file"
              :processId="props.row.process_file.process_id"
              :tooltipPosition="isMobile ? 'is-right' : 'is-top'"
            />
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="process_file.origin.entity.abbreviation"
            :label="General.ORIGIN"
            :sortable="!isMobile"
          >
            <div class="has-text-color-8 has-text-weight-semibold-500">
              {{ props.row.process_file.origin.entity.abbreviation }}
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="publish_date"
            :label="General.PUBLICATED"
            :sortable="!isMobile"
          >
            <div class="has-text-color-8">
              {{ new Date(props.row.publish_date) | dateFormat("DD/MM/YYYY") }}
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            class="is-narrow"
            field="user.last_name"
            :label="isMobile ? '' : General.ACTIONS"
            cellClass="doe-actions"
          >
            <ActionsGrouper
              :actions="actionList(props.row)"
              :customClass="isMobile ? 'is-align-self-flex-start' : ''"
            />
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <NoListMessage v-if="!isLoading" />
            <b-loading v-else :isFullPage="false" :active="isLoading" />
          </section>
        </template>

        <template slot="footer">
          <div
            :class="{ 'is-flex is-flex-direction-column-reverse': isMobile }"
          >
            <div class="column is-12 pl-0" :class="{ 'px-0': isMobile }">
              <span
                class="has-text-black column is-12 pl-0 has-text-weight-normal"
              >
                <b-dropdown
                  v-model="perPage"
                  aria-role="list"
                  position="is-top-right"
                  :expanded="isMobile"
                >
                  <template slot="trigger">
                    <b-button class="custom-dropdown-button custom-ph-8">
                      <label
                        >{{ perPage }}
                        {{ General.PER_PAGE.toLowerCase() }}</label
                      >

                      <b-icon class="spacing-mx-5" icon="chevron-down" />
                    </b-button>
                  </template>
                  <div class="has-text-color-8 spacing-p-5 has-text-centered">
                    {{ General.RECORDS_FOR_PAGE }}
                    <div class="list-page">
                      <b-dropdown-item
                        v-for="option in optionsPagination"
                        :key="option"
                        :value="option"
                        role="listbox"
                      >
                        <div role="listitem">
                          {{ option }}
                        </div>
                      </b-dropdown-item>
                    </div>
                  </div>
                </b-dropdown>
              </span>
            </div>
            <div class="columns is-centered">
              <div class="column is-6">
                <b-pagination
                  :total="doePublishedList.count"
                  :perPage="perPage"
                  :current.sync="currentPage"
                  rangeBefore="1"
                  rangeAfter="1"
                  order="is-centered"
                  class="process-panel-pagination"
                  rounded
                  :iconPrev="prevIcon"
                  :iconNext="nextIcon"
                  :aria-next-label="General.NEXT_PAGE"
                  :aria-previous-label="General.PREVIOUS_PAGE"
                  :aria-page-label="General.PAGE"
                  :aria-current-label="General.CURRENT_PAGE"
                  role="pagination"
                />
              </div>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UnifiedFilterSearch from "@/components/UnifiedFilterSearch";
import SubscriptionHistoryView from "@/components/SubscriptionHistoryView";
import NoListMessage from "@/components/NoListMessage";
import { App, General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";
import {
  DOE_PANEL_TABS as TABS,
  TAB_PERSIST_NAME as PERSIST_NAME,
  PROCESS_SUBJECT_ICONS as subjectIcons,
  USER_PERMISSIONS as userPermissions
} from "@/utils/enumerate";
import ModalChangePublishDOE from "@/views/App/ModalChangePublishDOE.vue";
import { formatPagination } from "@/utils/transformers";
import { debounce } from "lodash";
import { setPersistSort } from "@/plugins/indexDB";

export default {
  name: "DOEPublished",

  components: {
    UnifiedFilterSearch,
    SubscriptionHistoryView,
    NoListMessage
  },

  data() {
    return {
      App,
      General,
      userPermissions,
      subjectIcons,
      isLoading: false,
      observerPage: true,
      defaultSortField: "publish_date",
      sortField: JSON.stringify({ publish_date: "desc" }),
      defaultSortOrder: "desc",
      sortOrder: ["publish_date", "desc"],
      duePublishedList: [],
      sortIcon: "menu-up",
      sortIconSize: "is-medium",
      currentPage: 1,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      perPage: 10,
      searchValue: "",
      filterList: {},
      getItemsFilter: [
        "DOE_ORIGIN",
        "DOE_DATE",
        "DOE_SUBSCRIBER",
        "DOE_SUBJECT"
      ],
      ignoreOrderByPriority: false
    };
  },

  computed: {
    ...mapGetters({
      doePublishedList: "getDOEPublished",
      user: "getCurrentUser",
      hasPermission: "hasPermission",
      optionsPagination: "getItensPage",
      updateBySockets: "getUpdateBySockets",
      actualTab: "getCurrentTabDOEPanel",
      isConfidentialCheck: "isConfidentialCheck",
      getDoePageUpdater: "getDoePageUpdater",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    getPaginationDetails() {
      return formatPagination(
        this.doePublishedList,
        this.currentPage,
        this.perPage,
        "SIMPLIFIED"
      );
    },

    isValidSelection() {
      return this.duePublishedList.length < 2 ? true : false;
    },

    filterData() {
      let subscriber = [],
        origin = [],
        subject = [];
      subscriber = this.filterList?.subscriber?.map(filter => filter.id);
      origin = this.filterList?.origin?.map(filter => filter.id);
      subject = this.filterList?.subject?.map(filter => filter.id);

      let finalData = {};

      if (subscriber?.length) {
        const assigned_list = JSON.stringify(subscriber);
        finalData = { ...finalData, assigned_list };
      }

      if (this.filterList?.date?.start && this.filterList?.date?.end) {
        const formatedDate = JSON.stringify({
          start: this.filterList?.date?.start,
          end: this.filterList?.date?.end
        });
        finalData = { ...finalData, date: formatedDate };
      }

      if (origin?.length) {
        const formatedOrigin = JSON.stringify(origin);
        finalData = { ...finalData, origin: formatedOrigin };
      }

      if (subject?.length) {
        const formatedSubject = JSON.stringify(subject);
        finalData = { ...finalData, subject_list: formatedSubject };
      }

      return finalData;
    },

    requestBaseData() {
      return {
        page: this.currentPage,
        search: this.searchValue,
        order_by: this.sortField,
        paginator_count: this.perPage,
        filters: this.filterData,
        ignore_order_by_priority: this.ignoreOrderByPriority
      };
    },

    tabPersistName() {
      return `${PERSIST_NAME.DOE_PUBLICATED}_${this.user.id}`;
    },

    isCurrentTab() {
      return this.actualTab.value === TABS.PUBLICATED.value;
    }
  },

  watch: {
    searchValue() {
      if (this.currentPage === 1) this.getAllDOEData();
      else this.currentPage = 1;
    },

    currentPage: {
      handler() {
        this.getAllDOEData();
      }
    },

    perPage() {
      this.getAllDOEData();
    },

    filterData() {
      if (this.currentPage === 1) this.getAllDOEData();
      else this.currentPage = 1;
    },

    updateBySockets: {
      handler(value) {
        if (value === "update_analising") {
          this.getAllDOEData();
          this.$store.commit("clearUpdateBySockets");
        }
      }
    },

    actualTab(tab) {
      this.duePublishedList = [];
      if (tab.value === TABS.PUBLICATED.value) {
        this.getAllDOEData();
      }
    },

    doePublishedList: {
      handler() {
        this.duePublishedList = [];
      }
    },

    getDoePageUpdater() {
      if (this.isCurrentTab) {
        this.getAllDOEData();
      }
    }
  },
  async created() {
    this.observerPage = false;
    this.sortOrder = await this.getSortPersist({
      sortField: this.sortField,
      tabPersistName: this.tabPersistName
    });
    this.observerPage = true;
    this.onSort(...this.sortOrder);
  },

  methods: {
    ...mapActions({
      getSortPersist: "getPersistSortAction",
      doePublishedRequest: "doePublishedRequest"
    }),

    getSearchValue(value) {
      this.searchValue = value;
    },

    getFilterList(filterList) {
      this.filterList = filterList;
    },

    getAllDOEData: debounce(async function() {
      this.isLoading = true;
      if (this.isCurrentTab && this.observerPage)
        await this.doePublishedRequest(this.requestBaseData);
      this.isLoading = false;
    }, 1e3),

    onSort(field, order) {
      if (field === "default") {
        this.sortField = JSON.stringify({ [this.defaultSortField]: order });
        this.ignoreOrderByPriority = false;
      } else {
        this.sortField = JSON.stringify({ [field]: order });
        this.ignoreOrderByPriority = true;
      }
      this.sortOrder = [field, order];
      setPersistSort({ name: this.tabPersistName, sort: { [field]: order } });
      this.getAllDOEData();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },

    secrecyName(item) {
      return item.process_file.secrecy.name || "";
    },

    isConfidential(item) {
      return this.isConfidentialCheck(item.process_file.secrecy.id);
    },

    actionList(item) {
      return [
        {
          label: this.General.TO_VIEW,
          icon: "magnify-plus",
          link: `/app/documento/${item.process_file.id}?processId=${item.process_file.process_id}`
        },
        {
          label: this.General.CHANGE_REGISTER_DOE,
          icon: "calendar-edit",
          position: "is-left",
          callback: () => this.openModalChanePublish([item])
        }
      ];
    },

    openModalChanePublish(docs) {
      this.$buefy.modal.open({
        parent: this,
        component: ModalChangePublishDOE,
        props: {
          listDocuments: docs,
          onClose: () => {
            this.getAllDOEData();
          }
        },
        canCancel: ["escape", "x", "outside"],
        hasModalCard: true,
        trapFocus: true
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.due-date-label {
  font-size: 12px;
  color: $orange;
}
.tooltip-trigger a {
  padding-right: 8px;
}
</style>
